<!--
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2023-01-05 19:26:15
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @LastEditTime: 2023-01-06 18:20:52
 * @FilePath: \dzCloud\src\projects\tiktok\pages\batchModify\components\MaterialTree.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="dz-flex-start mt20">
        <div class="white-body-view left-view" v-loading="leftLoading">
            <!-- <el-button type="primary" @click="addNewRecord()">新增</el-button> -->
            <left-tree
                ref="customTree"
                :tree-data="treeData"
                :tree-expand-all="treeExpandAll"
                :tree-node-key="treeNodeKey"
                @handleMaterial="handleMaterial"
            />
        </div>
        <!-- 右侧 -->
        <!-- <tree-table ref="treeTable"></tree-table> -->
        <div class="right-view p20 ml20">
            <el-input
                v-model="queryParams.materialName"
                clearable
                class="w200 mr10"
                size="small"
                placeholder="素材名称"
            ></el-input>
            <el-date-picker
                v-model="queryParams.dateRange"
                size="small"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                @change="searchFun"
                class="mr10"
                clearable
            >
            </el-date-picker>
            <el-button type="primary" size="small" @click="searchFun">搜索</el-button>
            <el-button type="primary" size="small" @click="confirmUse">确认使用</el-button>
            <ul class="dfc main mt20" v-if="tableData.length > 0" v-loading="loading">
                <li v-for="(item, index) in tableData" :key="index" class="source-box mr20">
                    <div class="source-add dfcjc">
                        <div
                            class="img-box"
                            :style="{
                                backgroundImage: 'url(' + item.byteUrl + ')',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                margin: '10px',
                            }"
                        ></div>
                        <el-checkbox
                            v-model="item.checked"
                            class="checkbox"
                            @change="(val) => handleChecked(item, val)"
                        />
                    </div>
                    <p class="name-box mt10">{{ item.materialName }}</p>
                </li>
            </ul>
            <div v-else class="mt60">
                <noData>暂无数据</noData>
            </div>
            <div class="pagination" v-show="tableData.length != 0">
                <el-pagination
                    background
                    :page-size="queryParams.pageSize"
                    :current-page="queryParams.pageIndex"
                    :page-sizes="[5, 10, 20, 40]"
                    layout="prev, pager, next, total, jumper"
                    :total="queryParams.totalCount"
                    class="pagination"
                    small
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                />
            </div>
            <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px" append-to-body>
                <img width="100%" style="height: 600px" :src="dialogImageUrl" alt="" />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import LeftTree from './LeftTree';
// import TreeTable from './TreeTable';
import NoData from '../../materialCenter/components/NoData';
import Vue from 'vue';
export default {
    components: {
        LeftTree,
        // TreeTable,
        NoData,
    },
    props: {
        textData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            treeData: [],
            treeExpandAll: false,
            treeNodeKey: 'folderId',
            params: {
                totalCapacity: 0,
                usedCapacity: 0,
                pageIndex: 1, // 页码
                pageSize: 100, // 每页大小
            },
            leftLoading: false,
            checkDefault: [],
            queryParams: {
                pageIndex: 1, // 页码
                pageSize: 20, // 每页大小
                totalCount: 0,
                dateRange: '',
                folderId: '', //文件夹id，"0"--素材中心 "-1"--回收站
                materialName: '', //文件名称，支持模糊匹配
                orderType: 0, //排序方式，0-按照创建时间倒序 1-按照创建时间升序 6-按照素材大小降序 7-按照素材大小升序
            },
            checkAll: false, //全选
            checkedCities: [], //勾选
            tableData: [],
            loading: false,
            callBack: null,
            dialogImageUrl: '',
            dialogVisible: false,
            imgData: [],
        };
    },
    watch: {
        tableData: {
            handler() {},
            deep: true,
            immediate: false,
        },
    },
    created() {
        this.searchFolder();
    },
    methods: {
        /**
         * @description: 搜索文件夹
         * @param {string} parentFolderId 父文件夹id
         * @param {string} folderId 文件夹id
         * @param {integer} folderType 文件夹类型 0-用户创建 1-默认 2-系统文件夹
         * @param {integer} orderBy 排序方式 0-创建时间倒序 1-创建时间正序 2-修改时间倒序 3-修改时间正序 4-文件夹名倒序 5-文件夹名正序
         * @param {integer []} operateStatus 文件夹状态。1-有效 4-在回收站中
         * @return {*}
         */
        searchFolder() {
            let ajaxData = {
                orderBy: 0,
                pageNum: this.params.pageIndex,
                pageSize: this.params.pageSize,
                operateStatus: [1],
                parentFolderId: '0',
            };
            this.leftLoading = true;
            this.$ajax.post('/api/tiktok/Material/SearchFolder', ajaxData).then((res) => {
                this.leftLoading = false;
                if (res.result == []) {
                    res.result = [];
                }
                let data = res.result.folderInfoListEx.map((v) => {
                    return {
                        parentFolderId: v.parentFolderId,
                        folderId: v.folderId,
                        name: v.name,
                        createTime: v.createTime,
                        deleteTime: v.deleteTime,
                        folderType: v.folderType,
                        operateStatus: v.operateStatus,
                        updateTime: v.updateTime,
                        children: v.children,
                    };
                });
                this.treeData = [];
                this.treeData.push({
                    children: data,
                    folderId: '0',
                    name: '开放平台',
                });
                this.checkDefault.push(this.treeData[0].folderId);
                if (this.treeData.length != 0) {
                    let data = {
                        treeData: this.treeData[0], //初始化默认获取第一个
                        callBack: () => {
                            this.searchFolder();
                        },
                    };
                    // this.$refs.treeTable.searchList(data);
                    this.searchList(data);
                }
            });
        },
        // 点击节点
        handleMaterial(obj) {
            let data = {
                treeData: obj,
                callBack: () => {
                    this.searchFolder();
                },
            };
            /* this.$refs.treeTable.checkedCities = [];
            this.$refs.treeTable.checkAll = false;
            this.$refs.treeTable.searchList(data); */
            this.checkedCities = [];
            this.checkAll = false;
            this.searchList(data);
        },
        // 搜索
        searchFun() {
            this.queryParams.pageIndex = 1;
            this.searchList();
        },
        //右侧列表
        searchList(data) {
            this.loading = true;
            if (data) {
                this.queryParams.folderId = data.treeData.folderId;
                this.callBack = data.callBack;
            }
            let createTimeStart = '';
            let createTimeEnd = '';
            if (this.queryParams.dateRange) {
                createTimeStart = this.queryParams.dateRange[0];
                createTimeEnd = this.queryParams.dateRange[1];
            } else {
                createTimeStart = null;
                createTimeEnd = null;
            }
            let same = 0;
            let ajaxData = {
                createTimeStart,
                createTimeEnd,
                folderId: this.queryParams.folderId,
                materialName: this.queryParams.materialName,
                orderType: this.queryParams.orderType,
                pageNum: this.queryParams.pageIndex,
                pageSize: this.queryParams.pageSize,
            };
            this.$ajax
                .post('/api/tiktok/Material/SearchMaterial', ajaxData)
                .then((res) => {
                    this.loading = false;
                    if (res.code === 200) {
                        this.tableData = res.result.materialInfoList;
                        this.queryParams.totalCount = res.result.total;
                        //判断是否有勾选
                        this.tableData.forEach((item) => {
                            // var index = this.checkedCities.indexOf(item.materialId);
                            var index = this.checkedCities.findIndex((v) => v.materialId === item.materialId);
                            if (index == -1) {
                                Vue.set(item, 'checked', false);
                            } else {
                                Vue.set(item, 'checked', true);
                            }
                        });
                        this.checkedCities.forEach((i) => {
                            this.tableData.forEach((item) => {
                                if (item.materialId == i) {
                                    same += 1;
                                }
                            });
                        });
                        if (same == this.tableData.length && same != 0) {
                            this.checkAll = true;
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         *
         * @param item  勾选整行数据
         * @param val  勾选状态
         */
        handleChecked(item, val) {
            item['checked'] = val;
            for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].checked == false) {
                    this.checkAll = false;
                    break;
                } else {
                    this.checkAll = true;
                }
            }
            // var index = this.checkedCities.indexOf(item.materialId);
            var index = this.checkedCities.findIndex((v) => v.materialId === item.materialId);
            if (index == -1) {
                this.checkedCities.push(item);
            } else {
                this.checkedCities.splice(index, 1);
            }
        },
        getSuccess() {
            setTimeout(() => {
                this.searchList();
            }, 2000);
        },
        // 分页
        handleCurrentChange(val) {
            this.queryParams.pageIndex = val;
            this.checkAll = false;
            this.searchList();
        },
        handleSizeChange(size) {
            this.queryParams.pageIndex = 1;
            this.queryParams.pageSize = size;
            this.searchList();
        },
        showImg(v) {
            this.dialogVisible = true;
            this.dialogImageUrl = v;
        },
        //确认使用
        confirmUse() {
            if (this.treeData.type === 'main') {
                if (this.checkedCities.length > this.textData.max) {
                    this.$message.warning('主图只能选择一张');
                    return true;
                }
            } else if (this.treeData.type === 'top') {
                if (this.checkedCities.length > this.textData.max) {
                    this.$message.warning('首部图片只能选择三张');
                    return true;
                }
            } else {
                if (this.checkedCities.length > this.textData.max) {
                    this.$message.warning('尾部图片只能选择三张');
                    return true;
                }
            }
            this.$emit('confirmSuccess', this.checkedCities);
        },
    },
};
</script>

<style lang="scss" scoped>
.left-view {
    width: 300px;
    height: 594px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
}
.right-view {
    width: calc(100% - 320px);
    border: 1px solid #ebeef5;
    .main {
        flex-wrap: wrap;
        // width: 1656px;
        margin-bottom: 28px;
        max-height: 400px;
        overflow-y: auto;
        .source-box {
            // width: 9.2%;
            width: 120px;
            margin-bottom: 20px;
            .source-add {
                width: 100%;
                background: #f5f5f5;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #eeeeee;
                position: relative;
                // padding: 23px 12px 23px 12px;
                padding-bottom: 100%;
                .add-btn {
                    background: #2771fa;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #2771fa;
                    color: #fff;
                    width: 100%;
                    height: 36px;
                }
                .source-img {
                    width: 140px;
                    height: 117px;
                    // width: 100%;
                    // height: 100%;
                }
                .img-box {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0px;
                    // background: url("~@/assets/images/material.jpg") no-repeat center;
                    background-size: contain;
                }
                .checkbox {
                    position: absolute;
                    top: 0px;
                    /* left: 12px; */
                    right: 1px;
                }
                //遮罩
                .source-mask {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.2);
                    display: none;
                    .more-box {
                        width: 26px;
                        height: 16px;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 8px 8px 8px 8px;
                        position: absolute;
                        right: 0;
                        text-align: center;
                        top: 12px;
                        right: 12px;
                        padding: 1px 0 1px 0;
                        .more {
                            color: #fff;
                        }
                        .popover-written {
                            font-size: 15px;
                            font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
                            font-weight: bold;
                            color: #222222;
                        }
                    }
                    .more-active {
                        width: 26px;
                        height: 16px;
                        background: #ff6000;
                        border-radius: 8px 8px 8px 8px;
                        position: absolute;
                        right: 0;
                        text-align: center;
                        top: 12px;
                        right: 12px;
                        padding: 1px 0 1px 0;
                        .more {
                            color: #fff;
                        }
                    }
                    //按钮功能
                    .edit-button {
                        width: 75%;
                        // height: 36px;
                        // background: rgba(0, 0, 0, 0.5);
                        // border-radius: 18px;
                        // text-align: center;
                        // line-height: 36px;
                        position: absolute;
                        bottom: 12px;
                        left: 50%;
                        transform: translateX(-50%);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        > i {
                            color: #fff;
                            font-size: 19px;
                        }
                        .words {
                            color: #fff;
                            font-size: 14px;
                        }
                        .link-btn {
                        }
                    }
                }
            }
            //移入时显示
            .source-add:hover .source-mask {
                display: block;
            }
            .name-box {
                width: 100px;
                //超出一行省略号
                white-space: nowrap; //禁止换行
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .format-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 13px;
                .format-words {
                    font-size: 12px;
                    font-family: MicrosoftYaHeiUI;
                    color: #666666;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    .pagination {
        text-align: center;
        padding-bottom: 20px;
    }
}
</style>
